import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql, Link } from 'gatsby'
import { GlobalStyles } from './global-styles'

import CookieConsent from "react-cookie-consent";

import Header from './header'
import shareImg from './../images/1870-2000_030.jpg'
import '../styles/main.scss'
import './layout.css'

const Layout = ({ children, location, ...rest }) => (

  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            description
            keywords
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: data.site.siteMetadata.description },
            { name: 'keywords', content: data.site.siteMetadata.keywords },
          ]}
        >
          <html lang="en" />
          {/* OpenGraph tags */}
          <meta property="og:title" content={data.site.siteMetadata.title} />
          <meta property="og:description" content={data.site.siteMetadata.description} />
          <meta property="og:image" content={shareImg} />

          {/* Twitter Card tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={data.site.siteMetadata.title} />
          <meta name="twitter:description" content={data.site.siteMetadata.description} />
          <meta name="twitter:image" content={shareImg} />
        </Helmet>
        <GlobalStyles />
        <Header siteTitle={data.site.siteMetadata.title} location={location}/>
        <div className={'page_' + location.pathname.slice(1,-1)}>
          {children}
        </div>
        <CookieConsent
          className="cookie__banner"
          location="bottom"
          buttonText="Jag förstår"
          cookieName="centralstadencookieaccept"
          style={{ background: "#e2e1dd", color: "#000", fontSize: "14px" }}
          buttonStyle={{ color: "#fff", background: "#f06600", }}
          expires={150} >
          Cookies ger oss information om hur du använder sajten, så att vi kan förbättra upplevelsen för dig.
          <Link to="/about-cookie/" className="cookie__link">
          Läs mer om cookies.
          </Link>
        </CookieConsent>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
